export default __webpack_public_path__ + "static/media/cfo_1.29f68f82.jpg";